import { useEffect } from 'react';
import { isClient } from '@fhs/shared/src/utilities/ssr';

export function useWindowEvent(event, callback) {
    useEffect(() => {
        if (!isClient()) {
            return undefined;
        }

        window.addEventListener(event, callback);

        // Remove event listener on cleanup
        return () => window.removeEventListener(event, callback);

        // Use empty deps to ensure that the listener is only added once, on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export function useWindowResizeEvent(callback) {
    return useWindowEvent('resize', callback);
}
